import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class GrievanceService {

  grievanceUrl: string = environment.config.grievanceUrl;

  constructor(private http: HttpClient) { }

  saveGrievance(data) {
    return this.http.post<any>('https://uat.sbmurban.org/api/v1/grievance/complaint/post-complaint', data);
  }
  getCategory(name) {
    return this.http.get<any>(' https://uat.sbmurban.org/api/v1/system/type/' + name);
  }

  getGrievance(queryData) {
    return this.http.get<any>('http://grievance.sbmurban.org:8088/complaint/get-complaint/1/0/10', { params: queryData });
  }
  getGrievanceById(id) {
    return this.http.get<any>('https://uat.sbmurban.org/api/v1/grievance/complaint/get-complaint-by-id/' + id);
  }
  getCityBasicProgress(id) {
    return this.http.get<any>(this.grievanceUrl + 'area/' + id);
  }
  getCityBasicProgressList(queryData) {
    console.log('test1');
    return this.http.get<any>(this.grievanceUrl + 'area', { params: queryData });
  }
}
